import html2canvas from 'html2canvas';
// import { USER_VIDEO_ID } from './video-call-id';

/**
 * 截图
 * @param id 要被截图的dom的id值（默认截取用户的视频窗口）
 */
const captureScreen = async (id = 'USER_VIDEO_ID') => {
  const element = document.querySelector(`#${id}`) as HTMLElement;

  if (element) {
    const canvas = await html2canvas(element);

    return canvas;
  }

  throw '请传入真实存在的dom的id';
};

const canvasToBlob = (
  canvas: HTMLCanvasElement,
  type = 'image/png',
  quality?: any
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (blob) {
          resolve(blob);
        } else {
          reject('请传入正确的canvas元素');
        }
      },
      type,
      quality
    );
  });
};

export { captureScreen, canvasToBlob };
